/** CloudFront prod routes `/api/*` to the backend; root `/socket.io` hits the SPA bucket. */
export const SOCKET_IO_PATH = '/api/socket.io';
